import clsx from 'clsx';

import styles from './SummaryBox.module.css';
import IconButton from '../icon-button/IconButton';

function SummaryBox({ children, className, color, tittle, number, ...rest }) {
    return (
        <div
            {...rest}
            className={clsx(styles.box)}
            style={{
                backgroundColor: color,
            }}
        >
            <div className={clsx(styles.tittle)}>{tittle}</div>
            <div
                className={clsx(styles.numberWrapper)}
                style={{
                    borderColor: color,
                }}
            >
                <IconButton
                    className={clsx(styles.icon)}
                    style={{
                        color: color,
                    }}
                >
                    {children}
                </IconButton>
                <div
                    className={clsx(styles.number)}
                    style={{
                        color: color,
                    }}
                >
                    {number}
                </div>
            </div>
        </div>
    );
}

export default SummaryBox;
